import Alpine from 'alpinejs';

// Extend Analog's Menu. Its header stack still handles sticking and popup offsets.
Alpine.directive('sa-compact-header', (el, _, { effect, cleanup }) => {
  let compact = false;
  let lastY = window.scrollY;
  let threshold = el.offsetHeight + 24;
  let settling = false;
  let timer;
  let anchorValue;
  let anchorPriority;
  let width = window.innerWidth;
  const root = document.documentElement;
  const section = el.closest('.shopify-section');

  const restoreAnchoring = () => {
    if (anchorValue === undefined) return;
    if (anchorValue) root.style.setProperty('overflow-anchor', anchorValue, anchorPriority);
    else root.style.removeProperty('overflow-anchor');
    anchorValue = undefined;
  };

  const reflect = () => {
    const value = String(compact);
    if (el.dataset.saCompact !== value) el.dataset.saCompact = value;
  };

  const setCompact = (next) => {
    if (compact === next) return;
    // Prevent browser scroll anchoring from reversing the scroll direction as we resize.
    if (anchorValue === undefined) {
      anchorValue = root.style.getPropertyValue('overflow-anchor');
      anchorPriority = root.style.getPropertyPriority('overflow-anchor');
    }
    root.style.setProperty('overflow-anchor', 'none');
    // SA perf: keep the sticky section at its full height so page content never moves (CLS).
    // The spare band under the compact bar is transparent and lets clicks through.
    if (next && section && !section.style.minHeight) {
      section.style.minHeight = section.offsetHeight + 'px';
      section.style.pointerEvents = 'none';
      for (const child of section.children) child.style.pointerEvents = 'auto';
    }
    compact = next;
    settling = true;
    reflect();
    clearTimeout(timer);
    timer = setTimeout(() => {
      settling = false;
      lastY = window.scrollY;
      if (!compact) threshold = el.offsetHeight + 24;
      restoreAnchoring();
    }, 300);
  };

  reflect();
  effect(() => {
    const y = Math.max(0, Alpine.store('page')?.scrollY ?? window.scrollY);
    const menuOpen = Alpine.store('headerMenu')?.activePopupId;
    const drawerOpen = Alpine.store('drawer')?.isOpen;
    if (y <= 0) {
      setCompact(false);
      lastY = y;
      return;
    }
    if (settling || menuOpen || drawerOpen || el.querySelector(':focus-visible')) {
      lastY = y;
      return;
    }
    const delta = y - lastY;
    if (Math.abs(delta) < 12) return;
    if (delta < 0) setCompact(false);
    else if (y > threshold) setCompact(true);
    lastY = y;
  });

  const resize = new ResizeObserver(() => {
    if (!compact && !settling) threshold = el.offsetHeight + 24;
    if (window.innerWidth !== width) {
      width = window.innerWidth;
      if (section) section.style.minHeight = '';
      setCompact(false);
    }
  });
  resize.observe(el);

  // Cart refreshes morph this section; retain its current scroll state afterward.
  const attributes = new MutationObserver(reflect);
  attributes.observe(el, { attributes: true, attributeFilter: ['data-sa-compact'] });

  const select = (event) => {
    if (event.target === section) setCompact(false);
  };
  document.addEventListener('shopify:section:select', select);
  cleanup(() => {
    clearTimeout(timer);
    restoreAnchoring();
    resize.disconnect();
    attributes.disconnect();
    document.removeEventListener('shopify:section:select', select);
    el.removeAttribute('data-sa-compact');
  });
}).before('bind');
